var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.589844,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#003588"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_80_4605)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_80_4605)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7731 24.2225L19.7106 24.2172C19.7104 24.1869 19.7088 24.1566 19.7057 24.1264L18.7731 24.2225ZM36.3742 41.8167L36.4703 40.8841C36.4401 40.881 36.4098 40.8794 36.3795 40.8792L36.3742 41.8167ZM23.8195 28.0898L23.6715 27.1641C23.3716 27.212 23.1135 27.4023 22.9789 27.6746C22.8444 27.9469 22.8501 28.2674 22.9943 28.5348L23.8195 28.0898ZM32.5053 36.7723L32.0607 37.5977C32.328 37.7417 32.6485 37.7473 32.9207 37.6128C33.1929 37.4783 33.3831 37.2202 33.4311 36.9204L32.5053 36.7723ZM20.6942 21.3424C22.0366 20.0005 24.2133 20.0005 25.5558 21.3424L26.8814 20.0163C24.8067 17.9425 21.4432 17.9425 19.3686 20.0163L20.6942 21.3424ZM25.5558 21.3424C26.8981 22.6841 26.8981 24.8593 25.5558 26.201L26.8814 27.5271C28.9562 25.4531 28.9562 22.0903 26.8814 20.0163L25.5558 21.3424ZM34.3944 35.0372C35.7368 33.6953 37.9135 33.6953 39.256 35.0372L40.5816 33.7111C38.5069 31.6373 35.1434 31.6373 33.0688 33.7111L34.3944 35.0372ZM39.256 35.0372C40.5983 36.3789 40.5983 38.5541 39.256 39.8959L40.5816 41.222C42.6564 39.1479 42.6564 35.7851 40.5816 33.7111L39.256 35.0372ZM25.1136 35.4782C21.5813 31.9473 19.7304 27.7041 19.7106 24.2172L17.8356 24.2279C17.8589 28.3164 19.9911 33.0088 23.788 36.8043L25.1136 35.4782ZM19.7057 24.1264C19.6031 23.1309 19.933 22.1032 20.6942 21.3424L19.3686 20.0163C18.1915 21.193 17.6826 22.7856 17.8406 24.3187L19.7057 24.1264ZM39.256 39.8959C38.4948 40.6567 37.4665 40.9867 36.4703 40.8841L36.2782 42.7492C37.8114 42.9071 39.4045 42.3986 40.5816 41.222L39.256 39.8959ZM36.3795 40.8792C32.8908 40.8594 28.6459 39.0091 25.1136 35.4782L23.788 36.8043C27.585 40.5997 32.279 42.731 36.3689 42.7542L36.3795 40.8792ZM25.5558 26.201C25.023 26.7336 24.3614 27.0538 23.6715 27.1641L23.9674 29.0156C25.0342 28.8451 26.06 28.3481 26.8814 27.5271L25.5558 26.201ZM28.2072 32.3858C26.7223 30.9014 25.5286 29.2842 24.6447 27.6449L22.9943 28.5348C23.9673 30.3394 25.2718 32.1027 26.8816 33.7119L28.2072 32.3858ZM33.4311 36.9204C33.5414 36.231 33.8616 35.5697 34.3944 35.0372L33.0688 33.7111C32.2475 34.5321 31.7502 35.5577 31.5796 36.6242L33.4311 36.9204ZM32.95 35.947C31.31 35.0634 29.6921 33.8702 28.2072 32.3858L26.8816 33.7119C28.4915 35.3211 30.2554 36.6251 32.0607 37.5977L32.95 35.947Z",
    fill: "#FAFCFF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_80_4605"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(15 15.5898)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_80_4605"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(15 15.5898)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.9048984c1a784d77489698744304624f.svg";
export { ForwardRef as ReactComponent };